<div class="severity-count">
    <div class="critical">
        <!-- <mat-icon svgIcon="critical"></mat-icon> -->
        <div class="severity">Critical</div>
        <span>{{severity.critical}}</span>
    </div>
    <div class="danger">
        <div class="severity">Danger</div>
        <span>{{severity.danger}}</span>
    </div>
    <div class="warning">
        <div class="severity">Warning</div>
        <span>{{severity.warning}}</span>
    </div>
</div>
